import React from 'react';
import moment from "moment";

const displayDate = (dateStr) => {
    if (!dateStr) {
      return '-';
    }
    return moment(dateStr).format('HH:mm:ss');
}

const Header = ({ isTrackingActive, lastUpdated }) => (
    <div style={{ paddingTop: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <div className={`blob ${isTrackingActive ? '' : 'inactive'}`}></div>
                <h3>LIVE tracking</h3>
            </div>
            <div>
                <p style={{ margin: '0 10px 0 0' }}>
                    {lastUpdated && (<>Last seen at <span className="last-updated" key={`last-seen-${lastUpdated}`}>{displayDate(lastUpdated)}</span></>)}
                    {!lastUpdated && (<>-</>)}
                </p>
            </div>
        </div>
    </div>
);

export default Header;
